module.exports = __webpack_public_path__ + "static/img/changeSkin.70d2e32.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/changeSkin.png
// module id = Z4bW
// module chunks = 1